{
  "manager": {
    "title": "Мениджър табло",
    "welcome": "Добре дошли в мениджърското табло",
    "totalAppointments": "Общо срещи",
    "todaysAppointments": {
      "title": "Днешни срещи",
      "noAppointments": "Няма планирани срещи за днес",
      "noAppointmentsHint": "Вашият график е свободен днес.",
      "viewAll": "Виж календара",
      "anonymous": "Анонимен",
      "resource": "Ресурс {{id}}"
    },
    "completedThisWeek": "Завършени тази седмица",
    "activeClientLeads": "Активни клиентски лийдове",
    "statusOverview": "Преглед на статуса на срещите",
    "completed": "Завършени",
    "scheduled": "Планирани",
    "confirmed": "Потвърдени",
    "inProgress": "В процес",
    "cancelled": "Отменени",
    "quickActions": {
      "title": "Бързи действия",
      "scheduleAppointment": "Планирай среща",
      "scheduleAppointmentDesc": "Създай нова среща за клиент",
      "viewCalendar": "Виж календара",
      "viewCalendarDesc": "Виж всички срещи в календарен изглед",
      "manageLeads": "Управление на лийдове",
      "manageLeadsDesc": "Преглед и управление на всички клиентски лийдове",
      "manageResources": "Управление на ресурси",
      "manageResourcesDesc": "Конфигуриране на персонал, стаи и оборудване"
    },
    "scheduleNew": "Планирай нова среща",
    "addNewClient": "Добави нов клиент",
    "viewCalendar": "Виж календара",
    "sendReminders": "Изпрати напомняния",
    "todaysAppointmentsCard": "Днешни срещи",
    "recentClientLeads": "Последни клиентски лийдове",
    "upcomingAppointments": {
      "title": "Предстоящи срещи",
      "noAppointments": "Няма предстоящи срещи",
      "noAppointmentsHint": "Планирайте срещи, за да ги видите тук.",
      "viewAll": "Виж календара"
    },
    "noAppointmentsToday": "Няма планирани срещи за днес",
    "anonymousLead": "Анонимен лийд",
    "loading": "Зареждане на таблото...",
    "refresh": "Опресни",
    "servicesUnreachable": "Някои услуги са недостъпни",
    "failedAppointments": "Неуспешно зареждане на срещи.",
    "failedLeads": "Неуспешно зареждане на лийдове.",
    "retry": "Опитай отново",
    "stats": {
      "totalAppointments": "Общо срещи",
      "todaysAppointments": "Днешни срещи",
      "thisWeek": "Тази седмица",
      "totalLeads": "Общо лийдове",
      "newLeads": "Нови лийдове",
      "convertedLeads": "Конвертирани"
    },
    "leadPipeline": {
      "title": "Воронка на лийдове",
      "noLeads": "Все още няма лийдове",
      "noLeadsHint": "Лийдовете ще се показват тук, когато бъдат събрани чрез вашите канали."
    },
    "appointmentOverview": {
      "title": "Преглед на срещите",
      "allOperational": "Всички системи работят",
      "scheduled": "Планирани",
      "confirmed": "Потвърдени",
      "completed": "Завършени",
      "cancelled": "Отменени",
      "noShow": "Неявяване"
    },
    "recentLeads": {
      "title": "Последни лийдове",
      "noLeads": "Няма намерени лийдове",
      "noLeadsHint": "Лийдовете ще се показват тук, когато бъдат събрани.",
      "viewAll": "Виж всички ({{count}})"
    },
    "table": {
      "resource": "Ресурс"
    }
  },
  "admin": {
    "title": "Админ табло",
    "welcome": "Добре дошли в админ панела"
  },
  "client": {
    "title": "Клиентско табло",
    "welcome": "Добре дошли отново",
    "subtitle": "Вашите срещи и съобщения накратко",
    "stats": {
      "upcomingThisWeek": "Предстоящи тази седмица",
      "upcomingToday": "Предстоящи днес",
      "totalAppointments": "Вашите срещи",
      "openThreads": "Съобщения",
      "pendingRequests": "Чакащи заявки за преместване"
    },
    "upcomingAppointments": {
      "title": "Предстоящи срещи",
      "viewCalendar": "Към календара",
      "empty": "Няма предстоящи срещи",
      "anonymous": "Среща",
      "video": "Видео",
      "inPerson": "На място"
    },
    "pendingRequests": {
      "title": "Чакащи заявки за преместване",
      "empty": "Няма чакащи заявки за преместване",
      "requested": "Заявено",
      "statuses": {
        "PENDING": "Чакаща",
        "APPROVED": "Одобрена",
        "REJECTED": "Отхвърлена",
        "CANCELLED": "Отменена"
      }
    },
    "changeRequest": {
      "title": "Заяви промяна на среща",
      "sendRequest": "Изпрати заявка",
      "requestType": "Тип заявка",
      "typeReschedule": "Преместване на среща",
      "typeCancel": "Отмяна на среща",
      "currentAppointment": "Текуща среща",
      "chooseNewTime": "Изберете нов час",
      "durationMinutes": "{{minutes}} мин",
      "additionalInfo": "Допълнителна информация",
      "additionalInfoPlaceholder": "Незадължителни бележки за доставчика",
      "cancelReason": "Причина за отмяна",
      "appointmentLabel": "Среща",
      "deadlineBlocked": "Тази среща започва след един час или по-рано и вече не може да бъде променена онлайн. Моля, свържете се с нас директно.",
      "activeRequestExists": "Вече има чакаща заявка за промяна за тази среща.",
      "pendingOnAppointment": "Заявка за промяна на тази среща се преглежда.",
      "rescheduleInfo": "Избраната дата и час подлежат на потвърждение. Срещата ви няма да бъде преместена, докато заявката не бъде одобрена.",
      "cancelInfo": "Срещата ви ще бъде отменена веднага и часът ще бъде освободен.",
      "rescheduleSubmitted": "Вашата заявка за преместване е изпратена успешно. Ще получите потвърждение след преглед.",
      "cancelSubmitted": "Срещата ви беше отменена успешно.",
      "cancelAppointment": "Отмени срещата",
      "alreadyCancelled": "Тази среща вече е отменена.",
      "sameTimeAsCurrent": "Моля, изберете различна дата и час от текущата среща.",
      "submitFailed": "Заявката за промяна не можа да бъде изпратена."
    },
    "quickActions": {
      "title": "Бързи действия",
      "viewCalendar": "Календар",
      "requestChange": "Заяви промяна",
      "messages": "Съобщения",
      "profile": "Профил"
    },
    "scopeRequired": {
      "dashboard": "Изберете наемател и клиент в горната лента, за да видите клиентския портал",
      "calendar": "Изберете наемател и клиент в горната лента, за да видите календара",
      "threads": "Изберете наемател и клиент в горната лента, за да видите разговорите",
      "thread": "Изберете клиент в горната лента, за да видите този разговор"
    },
    "calendar": {
      "subtitle": "Преглед на вашите срещи"
    }
  }
}
